<template>
  <div class="house">
    <div
      class="rightmouse"
      :style="{ top: rightMouseTop + 'px', left: rightMouseLeft + 'px', opacity: rightMouseFlag ? '1' : '0' }"
    >
      <p>© 图片版权保护</p>
    </div>
    <div class="househeader">
      <div style="display:flex;align-items: center;">
        <img src="@/assets/house/breadicon.png" style="margin-right:10px" alt />
        <el-breadcrumb separator="/">
          <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
          <!-- <el-breadcrumb-item>工作桌面</el-breadcrumb-item> -->
          <el-breadcrumb-item>个人图库</el-breadcrumb-item>
          <el-breadcrumb-item>我的图片</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div @click="refresh" class="refresh">
        <img
          :class="isRefresh ? 'imgmove' : ''"
          width="16px"
          height="16px"
          src="@/assets/house/refresh.png"
          alt
        />
        <p>刷新</p>
      </div>
    </div>

    <div class="main" v-loading="isRefresh">
      <div class="head disflex">
        <div class="left">
          <h4 style="font-size:18px;margin-left:5px;">我的图片</h4>
        </div>

        <div class="right disflex">
          <div @click="sortClick" class="disflex">
            <p>按时间排序</p>
            <img
              style="margin:3px 0 0 5px;"
              :src="sortFlag ? require('@/assets/personpic/down.png') : isSimple ? require('@/assets/personpic/simpleup.png') : require('@/assets/personpic/up.png')"
              alt
            />
          </div>
        </div>
      </div>
      <div class="searchbj">
          <div class="belongpic">
            <h5>状态:</h5>
            <p
              v-for="(e,i) in statusList"
              :key="i"
              @click="statusClick(i, e.id)"
              :style="{ 'backgroundColor': statusPicFlag === i ? isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3' : '#ffffff' }"
              :class="statusPicFlag === i ? 'active' : ''"
            >{{ e.name }}</p>
          </div>

          <div class="belongpic">
            <h5>图片主题:</h5>
            <p
              v-for="(e,i) in themeList"
              :key="i"
              @click="pClick(0, i, e.name)"
              :style="{ 'backgroundColor': themeFlag === i ? isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3' : '#ffffff' }"
              :class="themeFlag === i ? 'active' : ''"
            >{{ e.name }}</p>
          </div>
          <div class="belongpic">
            <h5>所属环境:</h5>
            <p
              v-for="(e,i) in environmentList"
              :key="i"
              @click="pClick(1, i, e.name)"
              :style="{ 'backgroundColor': environmentFlag === i ? isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3' : '#ffffff' }"
              :class="environmentFlag === i ? 'active' : ''"
            >{{ e.name }}</p>
          </div>
          <div class="belongpic">
            <h5>图库:</h5>
            <p v-for="(e, i) in belongPicList" :key="i">
            <span
              v-if="!e.children"
              :style="{
                backgroundColor:
                  belongPicFlag === i
                    ? isCustom
                      ? customColor
                      : isSimple
                      ? '#FD9112'
                      : '#185ED3'
                    : '#ffffff',
              }"
              :class="belongPicFlag === i ? 'active' : ''"
              @click="pClick(2,i, e.id)"
              >{{ e.name }}</span
            >
            <span
              v-if="e.children && item.name"
              :style="{
                marginRight: '20px',
                backgroundColor:
                  belongPicFlag === index + (i*3) + 100
                    ? isCustom
                      ? customColor
                      : isSimple
                      ? '#FD9112'
                      : '#185ED3'
                    : '#ffffff',
              }"
              :class="belongPicFlag === index + (i*3) + 100 ? 'active' : ''"
              v-for="(item, index) in e.children"
              @click="pClick(2,index + (i*3) + 100, item.id)"
              :key="index"
            >
              {{ item.name }}({{ e.name }})
            </span>
            </p>
          </div>

          <div class="disFlex">
            <!-- 入库时间 -->
            <div class="coninput">
              <h5>入库时间:</h5>
              <el-date-picker
                v-model="warehousingTime"
                type="daterange"
                align="center"
                value-format="timestamp"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
              <!-- <i class="dateicon el-icon-date"></i> -->
            </div>
            <!-- 人物筛选 -->
            <div class="coninput">
              <h5 style="width:62px;">人物筛选:</h5>
              <el-select
                v-model="peopleFace"
                :remote-method="searchPeo"
                filterable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in peopleFaceList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>
            <!-- 关键字 -->
            <div class="coninput">
              <h5 style="width:52px;">关键字:</h5>
              <el-input
                class="elinput"
                v-model="selectInput"
                style="width:200px"
                placeholder="请输入关键字"
              ></el-input>
            </div>
            <el-button
              @click="searchClick"
              :style="{ 'backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3' }"
              class="btn"
            >搜索</el-button>
          </div>
        </div>
      <div class="piclist">
        

        <section ref="section" v-if="picList.length > 0">
          <div
            @click.stop="picList[0].src !== require('@/assets/house/grey.png') && openDialog(index, item)"
            class="img-wrapper"
            v-for="(item, index) in picList"
            :key="index"
          >
            <div class="imgBox">
              <el-image
                class="img"
                :style="{width:item.picW?item.picW*150/item.picH+'px' : '100'+'px'}"
                @contextmenu.prevent="rightShow($event)"
                ondragstart="return false;"
                fit="cover"
                :src="item.src"
              >
                <div slot="error" class="image-slot">
                  <img src="@/assets/house/onloadpicerror.png" alt />
                </div>
              </el-image>
            </div>

            <div class="dian">
                <img src="@/assets/piclist/dian.png" alt="">
                <div class="diannr">
                  <p @click.stop="removePic(item)">移出图片</p>
                  <p @click.stop="deletePic(item)">删除图片</p>
                  <p  @click.stop="downloadimg(item)">下载图片</p>
                  <p v-if="powersObj.selectPicture" @click.stop="lovePic(index,item)">
                    {{loveList.indexOf(item.resourceId) === -1 ? '选用图片' : '移除图片'}}
                  </p>
                  <p @click.stop="openChangeDesc(item)">修改图片说明</p>
                </div>
            </div>


            <!-- 修改图片信息 -->
            <!-- <el-tooltip class="item" effect="dark" content="修改图片说明" placement="top">
              <div @click.stop="openChangeDesc(item)" class="changedesc">
                <img src="@/assets/sreenpic/desc.png" alt />
              </div>
            </el-tooltip> -->

            <!-- 选用图片 -->
            <!-- <el-tooltip class="item" effect="dark" content="选用图片" placement="top">
              <div @click.stop="lovePic(index,item)" v-if="powersObj.selectPicture" class="love">
                <img v-if="loveList.indexOf(item.resourceId) === -1" src="@/assets/piclist/love.png" alt />
                <img v-if="loveList.indexOf(item.resourceId) > -1" src="@/assets/piclist/lovec.png" alt />
              </div>
            </el-tooltip> -->
          </div>

          <img
            v-if="showLoading"
            class="myloading"
            width="150px"
            src="@/assets/blue-preloader.gif"
            alt
          />
        </section>

        <div v-if="firstLoading" class="showGifFlag">
          <img width="150px" src="@/assets/blue-preloader.gif" alt />
        </div>

        <template v-if="!firstLoading && picList.length === 0">
          <div class="nopic">
            <img src="@/assets/piclist/nonr.png" alt />
          </div>
        </template>
      </div>
    </div>

    <changedescdialog
      :message.sync="message"
      ref='changedescdialog'
      :dialogVisible="descdialogVisible"
      @handleClose="deschandleClose"
      @changeDesc="changeDesc"
    ></changedescdialog>












    <!-- 图片点击弹窗 -->
    <el-dialog :visible.sync="dialogVisible"
               width="90%"
               top="12vh"
               class="seepic"
               :show-close="false">
      <!-- 关闭按钮 -->
      <div @click="dialogVisible = false"
           class="close">
        <img :style="{ 'margin-top': displayResolution < 1600 ? '-2px' : '0px' }"
             src="@/assets/picbrowse/close.png"
             alt />
      </div>

      <div class="left">
        <div class="pic"
             v-loading="imgLoading"
             element-loading-text="正在加载图片中"
             element-loading-spinner="el-icon-loading"
             element-loading-background="rgba(0, 0, 0, 0.8)">
          <!-- <el-button @click="openFace"
          style="position:absolute;top:20px;right:20px;">开关</el-button>-->
          <!-- <el-switch style="position:absolute;top:20px;right:20px;"
                     v-model="switechValue"
                     @change="clearLargeAndSmall">
          </el-switch>-->
          <div class="imgBj"
               ref="imgBj">
            <!-- <img ref="imgPic"
                 height="78%"
                 v-drag
                 v-lazy="choosePicMsg.src"
            v-if="!switechValue">-->
            <div
              ref="imgPic"
              @contextmenu.prevent="rightShow($event)"
              ondragstart="return false;"
              @click="seeBigSmall"
              :style="{ cursor:seeFull ? 'zoom-out' : 'zoom-in',height: '98%', width: '100%', backgroundImage: 'url(' + choosePicMsg.srcW1080 + ')', backgroundSize: 'contain', backgroundPosition: 'center center', backgroundRepeat: 'no-repeat' }"
            ></div>
            <!-- <img ref="imgPic"
                 @contextmenu.prevent="rightShow($event)"
                 ondragstart="return false;"
                 height="98%"
                 @click="seeBigSmall"
                 :style="seeFull ? 'cursor:zoom-out' : 'cursor:zoom-in'"
                 v-lazy="choosePicMsg.srcW1080" /> -->

            <div v-if="switechValue"
                 class="origin">
              <div class="faceBorder"
                   :style="'position: absolute;display:flex;justify-content:center;align-items:center;border:1px dashed #00ccff;;height:' +
                item.height + 'px;width:' +
                item.width + 'px;top:' +
                item.top + 'px;left:'
                + item.left + 'px;'"
                   v-for="(item,index) in choosePicMsg.faceInfo"
                   :key="index">
                <div style="width:93%;height:93%;border:1px dotted #666;">
                  <div class="yuan"
                       :style="{ 'left': (item.width - 20) + 'px', 'top': (item.height / 2) + 'px' }"></div>
                  <div class="faceName"
                       @click.stop="powersObj.myFace && !seeFull && addFacePeople(1, item, index)"
                       :title="item.faceName"
                       :style="{ 'left': (item.width - 10) + 'px', 'top': (item.height / 2 - 10) + 'px' }">{{ item.faceName.length > 11 ? item.faceName.substring(0, 11) + '…' : item.faceName }}</div>
                </div>
              </div>
            </div>
            <div @click="bigLeft"
                 class="leftjt">
              <!-- <div class="message"
                   v-show="showMessageLeft">这是第一张哟~</div> -->
            </div>
            <div @click="bigRight"
                 class="rightjt">
              <!-- <div class="message"
                   v-show="showMessageRight">这是最后一张哟~</div> -->
            </div>
            <i @click="picRotateRight"
               v-if="seeFull"
               class="el-icon-refresh-right"
               style="position:absolute; bottom:20px; left:45%; font-size: 30px;"></i>
            <i @click="picRotateLeft"
               v-if="seeFull"
               class="el-icon-refresh-left"
               style="position:absolute; bottom:20px;font-size: 30px;"></i>
          </div>

        </div>

        <div class="picinf disflex">
          <p class="picinfleft">
            <!-- {{ atlasInfo.name }} / 共
            <span>{{ atlasInfo.pictureCount }}</span>张图片和<span>{{atlasInfo.videoCount}}</span>个视频 -->
          </p>
          <div class="picinfright disflex">
            <div class="disflex" style="cursor:default;">
              <img src="@/assets/piclist/downloadin.png" alt="">
              <p style="marginRight:5px;">下载次数</p>
              <p>{{choosePicMsg.downloadCount}}</p>
            </div>
            <!-- <div class="disflex move"
                 @click="movePic">
              <div class="icon"></div>
              <p>移动</p>
            </div> -->
            <!-- <div @click.stop="seeFace"
                 v-if="!isSimple"
                 class="disflex face"
                 :style="{ background: !switechValue ? 'url(' + require('@/assets/picbrowse/face.png') + ') no-repeat' : 'url(' + require('@/assets/picbrowse/facehover.png') + ') no-repeat' }">
              <div class="icon"></div>
              <p :style="{ color: switechValue ? '#6ea4ff' : '#FFFFFF' }">人脸({{ faceLength }})</p>
            </div> -->
            <div v-if="powersObj.createAtlas"
                 @click.stop="lovePic"
                 class="disflex spare"
                 :style="{ background: !haslovechange ? 'url(' + require('@/assets/picbrowse/spare.png') + ') no-repeat' : 'url(' + require('@/assets/picbrowse/sparelove.png') + ') no-repeat' }">
              <div class="icon"></div>
              <!-- <img src="@/assets/picbrowse/spare.png" alt=""> -->
              <p>选用</p>
            </div>
            <div v-if="powersObj.createAtlas"
                 @click="removePic"
                 class="disflex remove">
              <div class="icon"></div>
              <!-- <img src="@/assets/picbrowse/delete.png" alt=""> -->
              <p>移出</p>
            </div>
            <div v-if="powersObj.createAtlas"
                 @click="deletePic"
                 class="disflex delete">
              <div class="icon"></div>
              <!-- <img src="@/assets/picbrowse/delete.png" alt=""> -->
              <p>删除</p>
            </div>
            <!-- <div v-if="powersObj.createAtlas"
                 @click="setIndexPic"
                 class="disflex book">
              <div class="icon"></div>
              <p>设为封面</p>
            </div> -->
            <!-- <div v-if="powersObj.createAtlas"
                 @click="deletePic"
                 class="disflex delete">
              <div class="icon"></div>
              <p>移出</p>
            </div> -->
          </div>
        </div>

        <div ref="piclist"
             class="piclist">
          <div v-if="picAllListFlag >= 13 || scroll < -1"
               @click="smallLeft"
               class="leftjt">
            <i style="font-size:30px;"
               class="el-icon-arrow-left"></i>
          </div>

          <div ref="picalllist"
               style="display:flex;transition:1s;">
            <div @click="picListClick(e, i)"
                 v-for="(e,i) in picList"
                 :key="i">
              <!-- <img :src="e.src" :class="picAllListFlag === i || choosePicMsg.id === i ? 'picimg active':'picimg'" /> -->
              <div :style="{ backgroundImage: 'url(' + e.src + ')', cursor: 'pointer' }"
                   @contextmenu.prevent="rightShow($event)"
                   ondragstart="return false;"
                   :class="picAllListFlag === i || choosePicMsg.myId === i ? 'picimg active' : 'picimg'"></div>
            </div>
          </div>

          <div v-if="picCha !== scroll && picList.length > 13"
               @click="smallRight"
               class="rightjt">
            <i style="font-size:30px;"
               class="el-icon-arrow-right"></i>
          </div>
        </div>
      </div>

      <div class="right">
        <div class="title">
          <p>图片信息</p>
        </div>
        <!-- <p><div class="key">用户名</div><div class="value">可爱无敌美少女</div></p> -->
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">拍摄时间</div>：
          <span>{{ picExif.CreateAtMy || '无' }}</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">上传时间</div>：
          <span>{{ picInfo.createAt || '无' }}</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">所属图库</div>：
          <span>{{ atlasInfo.libName || '无' }}</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">相机品牌</div>：
          <span>{{ picExif.Make || '暂无' }}</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">图片尺寸</div>：
          <span>{{ picInfo.picW }}*{{ picInfo.picH }}像素</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">图片大小</div>：
          <span>{{ picInfo.fileSize }}MB</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">图片格式</div>：
          <span>{{ picInfo.format }}</span>
        </div>
        <div v-if="picExif.ExposureTime"
             style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">曝光时间</div>：
          <span>{{ picExif.ExposureTime }}秒</span>
        </div>
        <div v-if="!picExif.ExposureTime"
             style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">曝光时间</div>：
          <span>暂无</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">ISO速度</div>：
          <span>{{ picExif.ISOSpeedRatings || '暂无' }}</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">图片焦距</div>：
          <span>{{ picExif.FocalLength || '暂无' }}</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">作者</div>：
          <span>{{ dataimgzuozhe || '暂无' }}</span>
        </div>

        <div style="margin-top:25px;"
             class="title"
             v-if="choosePicMsg.desc">
          <p>图片说明</p>
        </div>

        <p style="line-height:26px;padding-left:8px;">{{ choosePicMsg.desc }}</p>

        <div style="margin-top:25px;"
             class="title"
             v-if="choosePicMsg.labels.length > 0 && !isSimple">
          <p>智能标签</p>
          <div class="alert">仅供参考</div>
        </div>

        <div v-if="!isSimple"
             style="display:flex;align-items: center;flex-wrap: wrap;width:100%;margin-top:10px;">
          <div style="margin-left:5px;margin-bottom:5px;"
               v-for="(e,i) in choosePicMsg.labels"
               :key="i">
            <el-tag>{{ e }}</el-tag>
          </div>
        </div>

        <div style="margin-top:25px;"
             class="title"
             v-if="choosePicMsg.faceInfo ? choosePicMsg.faceInfo.length > 0 : false && !isSimple">
          <p>人物</p>
          <div class="alert">仅供参考</div>
        </div>

        <div v-if="!isSimple"
             style="display:flex;align-items: center;flex-wrap: wrap;width:100%;margin-top:10px;">
          <div style="margin-left:5px;margin-bottom:5px;cursor: pointer;"
               v-for="(e,i) in choosePicMsg.faceInfo"
               :key="i">
            <el-tag type="success"
                    @click.stop="powersObj.myFace && seepersonallface(e)">{{ e.faceName }}</el-tag>
          </div>
        </div>

        <div style="margin-top:25px;"
             class="title"
             v-if="choosePicMsg.logs.length > 0">
          <p>下载用户</p>
        </div>

        <div v-if="choosePicMsg.logs.length > 0"
             style="display:flex;align-items: center;flex-wrap: wrap;width:100%;margin-top:10px;">
          <div style="margin-left:5px;margin-bottom:5px;width:100%;"
               class="disflex"
               v-for="(e,i) in choosePicMsg.logs"
               :key="i">
            <p>{{e.createName}}</p>
            <p>{{e.createAtMY}}</p>
          </div>
        </div>

      </div>  


      <div class="msg disflex" v-if="false">
          <div class="picmsg">
            <p>{{ choosePicMsg.shareCount }}</p>
            <div>浏览量</div>
            <img src="@/assets/picbrowse/see.png"
                 alt />
          </div>
          <div class="picmsg">
            <p>{{ choosePicMsg.pushCount }}</p>
            <div>推送量</div>
            <img src="@/assets/picbrowse/msgpush.png"
                 alt />
          </div>
          <div class="picmsg">
            <p>{{ choosePicMsg.downloadCount }}</p>
            <div>平台数</div>
            <img src="@/assets/picbrowse/platform.png"
                 alt />
          </div>
        </div>
    </el-dialog>
      <el-dialog
        title="提示"
        :visible.sync="dialogVisibledefinition"
        width="30%"
        >
        <span >请选择下载清晰度!</span>

        <el-input style="margin-top:10px" v-model="input" placeholder="请输入打包标题"></el-input>
        <p style="margin-top:20px">分辨率:
          <el-radio-group v-model="radio">
          <el-radio :label="0">高</el-radio>
          <el-radio :label="1">中</el-radio>
          <el-radio :label="2">原图</el-radio>
          <el-radio :label="3">低</el-radio>
        </el-radio-group>
        </p>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisibledefinition = false">取 消</el-button>
          <el-button type="primary" @click="determine">确 定</el-button>
        </span>
      </el-dialog>

















  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import {
  removePictureAtlas
} from "@/api/atlas";
import { listUnclutteredPicture, deletePicture, updatePicture, bindingAtlas,getPictureLog,removePicturePic,getPictures } from '@/api/picture'
import { formatConversion } from '@/plugins/getdate'
import { listLib, listMyPowerLib } from "@/api/lib";
import { listWorkgroup } from "@/api/workgroup";
import { picPrefix } from "@/constants/piccommon";
import { addPicturePackage, getPicturePackage } from "@/api/picturePackage";
import { powersObj, allowLib } from "@/constants/powers";
import { searchAtlas, searchPicture, advSearchPicture, searchVideo } from "@/api/search";
import { addPeople, getPeopleConstant, listPeople } from "@/api/people";
import { setExtInfoapi } from "@/api/file";
import { setUserSetting, getUserSetting } from "@/api/config";

import { changedescdialog } from '@/components/index'

import { fullScreen, exitFullscreen, checkFull } from "@/plugins/fullScreen";

import picview from '@/components/picView/picView'
export default {
  inject: ['reload'],
  components: { changedescdialog, picview },
  computed: {
    ...mapGetters(["createUid"]),
  },
  data() {
    return {
            dialogVisibledefinition:false,
      downloadimgobj:{},
      radio:0,
      //选用图片
      loveList: [],
      //鼠标右击
      rightMouseTop: 0,
      rightMouseLeft: 0,
      rightMouseFlag: false,
      input:'',
      dataimgzuozhe:'',
      //状态筛选
      statusList: [
        {
          id: -1,
          name: "全部"
        },
        {
          id: 0,
          name: "私密"
        },
        {
          id: 1,
          name: "公开"
        }
      ],
      statusPicFlag: 0,
      //图片主题
      themeList: [
        {
          id: -1,
          name: "不限",
        },
        {
          id: "亲子活动",
          name: "亲子活动",
        },
        {
          id: "体育赛事",
          name: "体育赛事",
        },
        {
          id: "建设",
          name: "建设",
        },
        {
          id: "劳作",
          name: "劳作",
        },
        {
          id: "开会",
          name: "开会",
        },
        {
          id: "调研",
          name: "调研",
        },
        {
          id: "抗洪抢险",
          name: "抗洪抢险",
        },
        {
          id: "春节",
          name: "春节",
        },
        {
          id: "演讲",
          name: "演讲",
        },
        {
          id: "采访",
          name: "采访",
        },
      ],
      themeFlag: 0,
      theme: '',

      //所属环境
      environmentList: [
        {
          id: -1,
          name: "不限",
        },
        {
          id: "会场",
          name: "会场",
        },
        {
          id: "农田",
          name: "农田",
        },
        {
          id: "办公室",
          name: "办公室",
        },
        {
          id: "医院",
          name: "医院",
        },
        {
          id: "商超",
          name: "商超",
        },
        {
          id: "城市",
          name: "城市",
        },
        {
          id: "山川",
          name: "山川",
        },
        {
          id: "工厂",
          name: "工厂",
        },
        {
          id: "星空",
          name: "星空",
        },
        {
          id: "校园",
          name: "校园",
        },
        {
          id: "水源",
          name: "水源",
        },
        {
          id: "街道",
          name: "街道",
        },
      ],
      environmentFlag: 0,
      environment: '',

      //图库
      belongPicList: [
        {
          id: 0,
          name: "全部"
        }
      ],
      belongPicFlag: 0,
      belongPic: '',
      picId: '',
      sortFlag: true,
      warehousingTime: [],
      statusId: '',
      timeStart: '',
      timeEnd: '',
      selectInput: '',

      showLoading: false,
      firstLoading: false,


      //人物
      peopleFaceList: [],
      peopleFaceFlag: -1,
      peopleFace: '',

      //根据分辨率判断长度
      documentHeight: 0,


      descdialogVisible: false,


      //权限
      powersObj,
      allowLib,
      imglist:[],

      message: '',


      //分辨率
      row: 1,
      widthWithUP: '',
      displayResolution: 0,

      //图集间距
      atlasMargin: '',

      //侧边栏是否收起
      isAside: this.bus.val,

      picPrefix,




      //分页
      total: 0,
      pageSize: 50,
      page: 0,
      orderByTime: 0,

      //所有图集
      picList: [],



      isRefresh: false,



      //图片查看
      choosePicMsg: { isLove: false, labels: [], faceInfo: [] ,logs:[]},
      picAllListFlag: -1,
      dialogVisible: false,
      imgLoading: false,//图片加载
      scroll: 0,
      picCha: -1,

      faceLength: 0,

      atlasInfo: {},
      picExif:{},
      picInfo:{},
      seeSmall: true,
      seeFull: false,
      switechValue: false,
      haslovechange: false,
    };
  },
  methods: {
    ...mapActions(["setLoveList"]),
    determine(){
      if(this.input==''){
          this.$message({
          showClose: true,
          message: '请输入标题',
          type: 'warning'
        });
      }else{
      let params={
          createUid: localStorage.getItem('createUid'),
          downloadConfig:{
            thumb:''
          },
          packageType: "download",
          pictureCount: 1,
          pictureIds: this.downloadimgobj.resourceId,
          title:this.input
      }
      if(this.radio==0){
        params.downloadConfig.thumb = 'high'
        params.downloadConfig=JSON.stringify(params.downloadConfig)
        this.addPicturePackageapi(params)
      }else if(this.radio==1){
        params.downloadConfig.thumb = 'middle'
        params.downloadConfig=JSON.stringify(params.downloadConfig)
        this.addPicturePackageapi(params)
      }else if(this.radio==2){
        params.downloadConfig.thumb = 'original'
        params.downloadConfig=JSON.stringify(params.downloadConfig)
        this.addPicturePackageapi(params)
      }else if(this.radio==3){
        params.downloadConfig.thumb = 'small'
        params.downloadConfig=JSON.stringify(params.downloadConfig)
        this.addPicturePackageapi(params)

      }
        this.dialogVisibledefinition=false
      }

    },
    downloadimg(val){
      console.log(val);
    this.downloadimgobj=val
    this.dialogVisibledefinition=true
    },
    addPicturePackageapi(val){
      addPicturePackage(val).then(res=>{
        if(res.status){
          this.$router.push('/shareAndPush/myDownload')
        }
      })
    },
    //将图片删除之后放到未整理
    removePic (e) {
      this.$confirm("确认移出至未整理中吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(() => {
          let params
          if(e.resourceId){
            params = {
              atlasId: e.atlasId,
              pictureId: e.resourceId
            }
          }else{
            params = {
              atlasId: this.choosePicMsg.atlasId,
              pictureId: this.choosePicMsg.resourceId
            }
          }
          // this.unFormatAtlasAsync(this.atlasInfo.id)
          this.removePictureAtlasAsync(params)
        })
    },

    //将图片删除之后放到回收站
    deletePic (e) {
      this.$confirm("确认删除之后放到回收站吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(() => {
          if(e.resourceId){
            this.removePicturePicAsync(e.resourceId)
          }else{
            this.removePicturePicAsync(this.choosePicMsg.resourceId)
          }
        })
    },

    //将图片移除图集到未整理
    async removePictureAtlasAsync (val) {
      let { status, data, message, pagination, errors } = await removePictureAtlas(val);
      if (status) {
        this.$message.success("移出成功！")
        this.dialogVisible = false
        setTimeout(() => {
          this.refresh()
        }, 1000);

      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },
    //将图片移除图集到回收站
    async removePicturePicAsync (val) {
      let { status, data, message, pagination, errors } = await removePicturePic(val);
      if (status) {
        this.$message.success("删除成功！")
        this.dialogVisible = false
        setTimeout(() => {
          this.refresh()
        }, 1000);

      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //图片旋转
    picRotateLeft () {
      this.switechValue = false
      this.picDeg -= 90
      // if(this.picDeg >=360){
      //   this.picDeg = 0
      // }
      this.$refs.imgPic.style.transform = 'scale(' + this.picTimes + ') rotateZ(' + this.picDeg + 'deg)'
    },
    //图片旋转
    picRotateRight () {
      this.switechValue = false
      this.picDeg += 90
      // if(this.picDeg >=360){
      //   this.picDeg = 0
      // }
      this.$refs.imgPic.style.transform = 'scale(' + this.picTimes + ') rotateZ(' + this.picDeg + 'deg)'
    },
    

    //查看图片
    seeBigSmall () {

      this.$refs.imgPic.style.left = ''
      this.$refs.imgPic.style.top = ''
      this.picTimes = 1
      this.picDeg = 0
      this.$refs.imgPic.style.transform = 'scale(' + this.picTimes + ') rotateZ(' + this.picDeg + 'deg)';
      this.$store.commit('SET_BigImage', !this.$store.state.user.bigImage)
      if (this.$store.state.user.bigImage) {
        fullScreen(this.$refs.imgBj)
        this.seeFull = true
      } else {
        exitFullscreen()
        this.seeFull = false
      }
    },

    //判断选中的图片在什么位置
    beSurePic(i, num) {
      if (i > num) {
        let picalllistwidth = this.$refs.picalllist.offsetWidth;
        let piclistwidth = this.$refs.piclist.offsetWidth;
        this.scroll = i * - 96;
        // console.log(piclistwidth - picalllistwidth)
        if (this.scroll < piclistwidth - picalllistwidth) {
          this.scroll = piclistwidth - picalllistwidth - 40;
          this.picCha = this.scroll;
        }
        this.$refs.picalllist.style.transform =
          "translateX(" + this.scroll + "px)";
      } else {
        this.$refs.picalllist.style.transform = "translateX(" + 0 + ")";
        this.scroll = 0;
      }
    },

    //获取图片信息
    getPicInfo (e) {
      this.picInfo.picH = e.picH || "1920";
        this.picInfo.picW = e.picW || "1080";
        this.picInfo.format =
          e.ext || "jpg";
        this.picInfo.createAt = formatConversion(
          e.fileCreateAt.toString()
        ).substring(0, 10);
        this.picInfo.fileSize =
          (e.fileSize / 1024 / 1024).toFixed(2) || "暂无";


        if (e.fileCreateAt) {
          this.picExif.CreateAtMy = '';
          this.picExif.CreateAtMy = formatConversion(
            e.createAt.toString()
          ).substring(0, 10);
        } else {
          this.picExif.CreateAtMy = null;
        }
      // this.BigfileId = e.fileId
      // this.BigfileInfo = e.fileInfo
      // this.listPeopleFaceByFileIdAsync(e.fileId, e.fileInfo)
    },

    //获取图片日志
    async getPictureLogAsync(val) {
      let { status, data, message, errors } = await getPictureLog(val);
      if (status) {
        this.choosePicMsg.logs = data
        if(this.choosePicMsg.logs.length > 0){
          for (let i = 0; i < this.choosePicMsg.logs.length; i++) {
            this.choosePicMsg.logs[i].createAtMY = formatConversion(this.choosePicMsg.logs[i].createAt.toString())
            this.choosePicMsg.logs[i].createName = this.choosePicMsg.logs[i].createUserInfo.name
          }
        }

        this.$forceUpdate()
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
      }
    },

    openDialog(i,e){
      
  if(e.fileExif){
        this.dataimgzuozhe=e.fileExif.author
     }
      
      this.switechValue = false

      this.dialogVisible = true

      this.choosePicMsg = e
      this.choosePicMsg.logs = []
      if(this.choosePicMsg.tags){
        this.choosePicMsg.labels = this.choosePicMsg.tags.split(',')
      }else{
        this.choosePicMsg.labels = []
      }
      this.choosePicMsg.myId = i

      this.picAllListFlag = i;

      this.getPictureLogAsync({
        id:this.choosePicMsg.resourceId,
        type:'download',
        pageSize:100000
      })

      let picLoveString = sessionStorage.getItem("picLove");
      let picLoveArray = JSON.parse(picLoveString)

      this.choosePicMsg.isLove = false
      this.haslovechange = false
      if (picLoveArray !== null) {
        for (let j = 0; j < picLoveArray.length; j++) {
          if (picLoveArray[j].id === this.choosePicMsg.resourceId) {
            this.choosePicMsg.isLove = true
            this.haslovechange = true
          }

        }
      }

      this.getPicInfo(e)

      this.$nextTick(()=>{
        
        this.beSurePic(i, 10)
      })


      // setTimeout(() => {
      //     this.imgPicHeight = this.$refs.imgPic.clientHeight || 279
      //     this.BigfileId = e.fileId
      //     this.BigfileInfo = e.fileInfo
      //     this.listPeopleFaceByFileIdAsync(e.fileId, e.fileInfo)
      //   }, 1000);
    },
    picListClick(e,i){
      this.choosePicMsg = e
      this.choosePicMsg.logs = []
      if(this.choosePicMsg.tags){
        this.choosePicMsg.labels = this.choosePicMsg.tags.split(',')
      }else{
        this.choosePicMsg.labels = []
      }
      
      this.choosePicMsg.myId = i

      this.picAllListFlag = i;

      this.getPictureLogAsync({
        id:this.choosePicMsg.resourceId,
        type:'download',
        pageSize:100000
      })


      let picLoveString = sessionStorage.getItem("picLove");
      let picLoveArray = JSON.parse(picLoveString)

      this.choosePicMsg.isLove = false
      this.haslovechange = false
      if (picLoveArray !== null) {
        for (let j = 0; j < picLoveArray.length; j++) {
          if (picLoveArray[j].id === this.choosePicMsg.resourceId) {
            this.choosePicMsg.isLove = true
            this.haslovechange = true
          }

        }
      }

      this.getPicInfo(e)

      this.$nextTick(()=>{
        this.beSurePic(i, 10)
      })
    },

    bigRight(){

      if (this.choosePicMsg.myId === this.picList.length - 1) {
        return
      }

      let myId = this.choosePicMsg.myId

      this.choosePicMsg = this.picList[this.choosePicMsg.myId + 1]
      if(this.choosePicMsg.fileExif){
        this.dataimgzuozhe=this.choosePicMsg.fileExif.author
        }else{
            this.dataimgzuozhe=''
        }
      this.choosePicMsg.logs = []
      if(this.choosePicMsg.tags){
        this.choosePicMsg.labels = this.choosePicMsg.tags.split(',')
      }else{
        this.choosePicMsg.labels = []
      }
      this.choosePicMsg.myId = myId + 1

      this.picAllListFlag = this.choosePicMsg.myId

      this.getPictureLogAsync({
        id:this.choosePicMsg.resourceId,
        type:'download',
        pageSize:100000
      })

      let picLoveString = sessionStorage.getItem("picLove");
      let picLoveArray = JSON.parse(picLoveString);

      this.choosePicMsg.isLove = false;
      this.haslovechange = false;
      if (picLoveArray !== null) {
        for (let j = 0; j < picLoveArray.length; j++) {
          if (picLoveArray[j].id === this.choosePicMsg.id) {
            this.choosePicMsg.isLove = true;
            this.haslovechange = true;
          }
        }
      }

      this.getPicInfo(this.choosePicMsg)

      this.beSurePic(this.choosePicMsg.myId,10)
    },
    bigLeft(){
      
      if (this.choosePicMsg.myId === 0) {
        return
      }

      let myId = this.choosePicMsg.myId

      this.choosePicMsg = this.picList[this.choosePicMsg.myId - 1]
     if( this.choosePicMsg.fileExif){
        this.dataimgzuozhe= this.choosePicMsg.fileExif.author
     }else{
        this.dataimgzuozhe=''
     }
      this.choosePicMsg.logs = []
      if(this.choosePicMsg.tags){
        this.choosePicMsg.labels = this.choosePicMsg.tags.split(',')
      }else{
        this.choosePicMsg.labels = []
      }
      this.choosePicMsg.myId = myId - 1

      this.picAllListFlag = this.choosePicMsg.myId

      this.getPictureLogAsync({
        id:this.choosePicMsg.resourceId,
        type:'download',
        pageSize:100000
      })

      let picLoveString = sessionStorage.getItem("picLove");
      let picLoveArray = JSON.parse(picLoveString);

      this.choosePicMsg.isLove = false;
      this.haslovechange = false;
      if (picLoveArray !== null) {
        for (let j = 0; j < picLoveArray.length; j++) {
          if (picLoveArray[j].id === this.choosePicMsg.id) {
            this.choosePicMsg.isLove = true;
            this.haslovechange = true;
          }
        }
      }

      this.getPicInfo(this.choosePicMsg)

      this.beSurePic(this.choosePicMsg.myId,10)
    },
    smallRight(){
      let picalllistwidth = this.$refs.picalllist.offsetWidth
      let piclistwidth = this.$refs.piclist.offsetWidth
      this.scroll = this.scroll - 300
      if (this.scroll < piclistwidth - picalllistwidth) {
        this.scroll = piclistwidth - picalllistwidth - 70
        this.picCha = this.scroll
        // console.log(this.scroll)
      }

      this.$refs.picalllist.style.transform = "translateX(" + this.scroll + "px)";
    },
    smallLeft(){
      this.scroll = this.scroll + 300
      if (this.scroll > 0) {
        this.$refs.picalllist.style.transform = "translateX(" + 0 + "px)";
        this.scroll = 0
      } else {
        this.$refs.picalllist.style.transform = "translateX(" + this.scroll + "px)";
      }
    },



    //操作
    movePic(){},




    //选用图片
    lovePicOut(i, e) {
      // return
      if (this.picList[i].errortext == 'error') {
        this.$message.warning('图片生成失败，无法添加到选用图片!');
        return false
      }
      this.choosePicMsg = e
      this.choosePicMsg.myId = i
      this.lovePic()
    },

    //图片选用
    lovePic(index,item) {

      let picLoveString = sessionStorage.getItem("picLove");
      let picLoveArray = JSON.parse(picLoveString)


      if (item) {
        if (!item.isLove) {
          this.loveList.push(item.resourceId);
          this.setLoveList(this.loveList);
          this.picList[index].isLove = true;
          if (!picLoveArray) {
            let pL = [];
            pL.push(item);
            sessionStorage.setItem("picLove", JSON.stringify(pL));
            this.setUserSettingAsync(this.createUid, "picLove", {
              value: item.resourceId,
            });
            this.$message.success("添加成功");
          } else {
            picLoveArray.push(item);
            sessionStorage.setItem("picLove", JSON.stringify(picLoveArray));
            let idsInfo = [];
            console.log(picLoveArray);
            for (let k = 0; k < picLoveArray.length; k++) {
              idsInfo.push({
                id: picLoveArray[k].resourceId ? picLoveArray[k].resourceId : picLoveArray[k].id,
              });
            }
            this.setUserSettingAsync(this.createUid, "picLove", {
              value: idsInfo,
            });
            this.$message.success("添加成功");
          }

          this.$forceUpdate()
        } else {
          this.loveList.splice(this.loveList.indexOf(item.resourceId), 1);
          this.setLoveList(this.loveList);
          
          this.picList[index].isLove = false;

          if (picLoveArray.length === 1) {
            sessionStorage.removeItem("picLove");
            this.setUserSettingAsync(this.createUid, "picLove", {
              value: null,
            });
            this.$message.success("移除成功");
          } else {
            let f;
            for (let i = 0; i < picLoveArray.length; i++) {
              if (item.resourceId === picLoveArray[i].id) {
                f = i;
              }
            }
            // console.log(picLoveArray)
            picLoveArray.splice(f, 1);
            sessionStorage.setItem("picLove", JSON.stringify(picLoveArray));
            let idsInfo = [];
            for (let k = 0; k < picLoveArray.length; k++) {
              idsInfo.push({
                id: picLoveArray[k].id,
              });
            }
            this.setUserSettingAsync(this.createUid, "picLove", {
              value: idsInfo,
            });
            this.$message.success("移除成功");
          }

          this.$forceUpdate()
        }
      }else{
        if (!this.choosePicMsg.isLove) {
          this.loveList.push(this.choosePicMsg.resourceId);
          this.setLoveList(this.loveList);
          this.choosePicMsg.isLove = true;

          this.haslovechange = true;
            this.imglist.push(this.choosePicMsg)
            sessionStorage.setItem("picLove", JSON.stringify(this.imglist));
            this.setUserSettingAsync(this.createUid, "picLove", {
              value: this.choosePicMsg.id,
            });
            this.$message.success("添加成功");
          // if (!picLoveArray) {
          //   let pL = [];
          //   pL.push(this.choosePicMsg);
          //   sessionStorage.setItem("picLove", JSON.stringify(pL));
          //   this.setUserSettingAsync(this.createUid, "picLove", {
          //     value: this.choosePicMsg.id,
          //   });
          //   this.$message.success("添加成功");
          // } else {
          //   picLoveArray.push({ id: this.choosePicMsg.id });
          //   sessionStorage.setItem("picLove", JSON.stringify(picLoveArray));
          //   let idsInfo = [];
          //   console.log(picLoveArray);
          //   for (let k = 0; k < picLoveArray.length; k++) {
          //     idsInfo.push({
          //       id: picLoveArray[k].resourceId,
          //     });
          //   }
          //   this.setUserSettingAsync(this.createUid, "picLove", {
          //     value: idsInfo,
          //   });
          //   this.$message.success("添加成功");
          // }
        } else {
          this.loveList.splice(this.loveList.indexOf(this.choosePicMsg.resourceId), 1);
          this.setLoveList(this.loveList);

          this.choosePicMsg.isLove = false;

          this.haslovechange = false;

          if (picLoveArray.length === 1) {
            sessionStorage.removeItem("picLove");
            this.setUserSettingAsync(this.createUid, "picLove", {
              value: null,
            });
            this.$message.success("移除成功");
          } else {
            let f;
            for (let i = 0; i < picLoveArray.length; i++) {
              if (this.choosePicMsg.id === picLoveArray[i].resourceId) {
                f = i;
              }
            }
            // console.log(picLoveArray)
            picLoveArray.splice(f, 1);
            let idsInfo = [];
            for (let k = 0; k < picLoveArray.length; k++) {
              idsInfo.push({
                id: picLoveArray[k].resourceId,
              });
            }
            sessionStorage.setItem("picLove", JSON.stringify(picLoveArray));
            this.setUserSettingAsync(this.createUid, "picLove", {
              value: idsInfo,
            });
            this.$message.success("移除成功");
          }
        }
      }
    },

    //设置选用图片
    async setUserSettingAsync(val, val2, data1) {
      let { status, data, message, errors } = await setUserSetting(val, val2, data1);
      if (status) {
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //获取选用图片
    async getUserSettingAsync(val, val2) {
      let { status, data, message, errors } = await getUserSetting(val, val2);
      if (status) {
        let piclove = JSON.parse(data);
        // console.log(piclove);
        if (piclove.value == null) {
          sessionStorage.removeItem("picLove");
        } else {

          let picIds = []
          for (let i = 0; i < piclove.value.length; i++) {
            picIds.push(piclove.value[i].id)
          }
          picIds = picIds.join(',');
          // console.log(picIds);
          let idsInfo = await getPictures({ ids: picIds });
          for (let j = 0; j < idsInfo.data.length; j++) {
            idsInfo.data[j].srcW1080 = this.picPrefix + idsInfo.data[j].fileInfo.picThumbW1080
            idsInfo.data[j].src = this.picPrefix + idsInfo.data[j].fileInfo.picThumbH160
          }
          // console.log(idsInfo.data);
          sessionStorage.setItem("picLove", JSON.stringify(idsInfo.data));
        }
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //状态筛选
    statusClick(i, id) {
      this.statusPicFlag = i;
      this.statusId = id;
      this.searchClick()
    },
    //筛选
    pClick(i, index, id) {
      switch (i) {
        case 0:
          this.themeFlag = index
          if (id == '不限') {
            this.theme = ''
          } else {
            this.theme = id
          }
          break;
        case 1:
          this.environmentFlag = index
          if (id == '不限') {
            this.environment = ''
          } else {
            this.environment = id
          }
          break;
        case 2:
          this.belongPicFlag = index
          if (id == '全部') {
            this.belongPic = ''
          } else {
            this.belongPic = id
          }
          break;
        default:
          this.belongPic = ''
          this.theme = ''
          this.environment = ''
          this.themeFlag = 0
          this.environmentFlag = 0
          this.belongPicFlag = 0
          break;
      }

      this.searchClick()

    },

    //图片右击
    rightShow(e) {
      this.rightMouseLeft = e.clientX
      this.rightMouseTop = e.clientY
      setTimeout(() => {
        this.rightMouseFlag = true
      }, 200);
      setTimeout(() => {
        this.rightMouseFlag = false
      }, 2000);
      // this.$message('版权所有')
    },

    //获取人物列表
    async listPeopleAsync(val) {
      let { status, data, message } = await listPeople(val);
      if (status) {
        this.peopleFaceList = [];
        this.peopleFaceList = [
          {
            id: -1,
            name: "不限",
          },
        ];
        for (let i = 0; i < data.length; i++) {
          this.peopleFaceList.push({
            id: data[i].id,
            name: data[i].peopleName,
          });
        }
      }
    },

    //
    async addPicturePackageAsync(val) {
      let { status, data, message, errors } = await addPicturePackage(val);
      if (status) {
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
      }
    },
    //检索人物
    searchPeo() {
      this.peopleFaceFlag = -1
      if (this.peopleFaceSearch) {
        let data = { pageSize: 30, name: this.peopleFaceSearch, fuzzySearch: true };
        this.listPeopleAsync(data);
      } else {
        let data = { pageSize: 30 };
        this.listPeopleAsync(data);
      }
    },

    //
    async listWorkgroupAsync(val) {
      let { status, data, message, errors } = await listWorkgroup(val);
      if (status) {
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
      }
    },








    deleteAtlas() { //删除图集
      this.$confirm('确认删除已选图集吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      }).then(() => {
        this.picIds = []
        for (let i = 0; i < this.picList.length; i++) {
          if (this.picList[i].updateFlag) {
            this.picIds.push(this.picList[i].id)
          }
        }
        for (let i = 0; i < this.picIds.length; i++) {
          this.deleteAtlasAsync(this.picIds[i], i)
        }
      }).catch(() => {
      })

    },

    //修改图片说明
    changeDesc(val) {
      setExtInfoapi({id:val.fileId},JSON.stringify(val.fileExif)).then(res=>{
        if(res.status){
        this.$message.success("修改成功！");
        }
      })
      this.updatePictureAsync(val)
      this.descdialogVisible = false
    },
    deschandleClose() {
      this.descdialogVisible = false
    },
    openChangeDesc(val) {
      console.log(val);
      val.id = val.resourceId
      this.message = val
      if(this.message.fileExif==null){
            this.message.fileExif={}
            this.message.fileExif.author=''
      }else{
          if(this.message.fileExif.author){
              this.$refs.changedescdialog.data= this.message.fileExif.author
          }
      }
     
      this.listLibAsync()
      this.descdialogVisible = true
    },
    //修改图片说明
    async updatePictureAsync(val) {
      let { status, data, message, errors } = await updatePicture(val);
      if (status) {
        this.$message.success("修改成功！")
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },





    searchClick() {
      this.firstLoading = true
      this.picList = []
      if (this.warehousingTime) {
        // if (this.warehousingTime[0] == this.warehousingTime[1]) {
          this.warehousingTime[0] = this.warehousingTime[0];
          this.warehousingTime[1] = this.warehousingTime[1] + 86400000;
        // }
        if (this.warehousingTime[0]) {
          this.timeStart = this.warehousingTime[0] / 1000;
          this.timeEnd = this.warehousingTime[1] / 1000;
        }
      } else {
        this.timeStart = "";
        this.timeEnd = "";
      }

      let labels = [];
      if (!this.environment && !this.theme) {
        labels = null;
      } else {
        if (this.environment) {
          labels.push(this.environment);
        }
        if (this.theme) {
          labels.push(this.theme);
        }

        labels = labels.join(",");
      }

      let peopleName = ''
      if (this.peopleFace) {
        if (this.peopleFace !== -1) {
          for (let i = 0; i < this.peopleFaceList.length; i++) {
            if (this.peopleFaceList[i].id == this.peopleFace) {
              peopleName = this.peopleFaceList[i].name
            }

          }
        }

      }

      this.page = 0;

      let params = {
        createUid: this.createUid,
        keyword: this.selectInput,
        libId: this.belongPic,
        timeStart: this.timeStart,
        timeEnd: this.timeEnd,
        page: this.page,
        pageSize: this.pageSize,
        orderByTime: this.orderByTime,
        status: this.statusId,
        peopleName: peopleName,
        labels: labels
      };
      this.advSearchPictureAsync(params)
    },




    //刷新
    refresh() {
      this.firstLoading = true
      this.timeStart = "";
      this.timeEnd = "";

      this.warehousingTime = []
      this.picList = []

      this.statusPicFlag = 0
      this.belongPicFlag = 0
      this.themeFlag = 0
      this.environmentFlag = 0
      this.selectInput = ''
      this.belongPic = ''
      this.peopleFace = ''
      this.theme = ''
      this.environment = ''
      this.environment = ''
      this.peopleFace = ''

      this.page = 0
      this.orderByTime = 0
      this.sortFlag = true

      //获取图集
      let params = {
        createUid: this.createUid,
        page: this.page,
        pageSize: this.pageSize,
        orderByTime: this.orderByTime,
      };
      this.advSearchPictureAsync(params)

      this.displayResolution = document.documentElement.clientWidth;

    },




    //排序
    sortClick() {
      this.sortFlag = !this.sortFlag;
      this.page = 0
      if (this.orderByTime == 0) {
        this.orderByTime = 1
      } else {
        this.orderByTime = 0
      }

      this.searchClick()
    },

    //滚动加载图库和图片
    scrollMine(e) {
      // let isBottom = (document.documentElement.scrollTop + window.innerHeight) === document.body.offsetHeight
      let isBottom =
        document.documentElement.scrollTop + window.innerHeight + 50 >=
        document.body.offsetHeight;
      // let isBottom =
      //   e.target.scrollTop + 463 >=
      //   this.$refs.section.offsetHeight;
        // var scrollTop=document.documentElement.scrollTop||document.body.scrollTop;
      // var scrollTop =
      //   document.documentElement.scrollTop || document.body.scrollTop;
      // //变量windowHeight是可视区的高度
      // var windowHeight =
      //   document.documentElement.clientHeight || document.body.clientHeight;
      // //变量scrollHeight是滚动条的总高度
      // var scrollHeight =
      //   document.documentElement.scrollHeight || document.body.scrollHeight;
      // console.log(isBottom);
      // return
      console.log('我的图片',isBottom);
      if (isBottom) {

        if (this.picList.length !== this.total) {
          this.showLoading = true
          setTimeout(() => {
            this.page++
            if (this.warehousingTime) {
              if (this.warehousingTime[0] == this.warehousingTime[1]) {
                this.warehousingTime[0] = this.warehousingTime[0];
                this.warehousingTime[1] = this.warehousingTime[1] + 86400000;
              }
              if (this.warehousingTime[0]) {
                this.timeStart = this.warehousingTime[0] / 1000;
                this.timeEnd = this.warehousingTime[1] / 1000;
              }
            } else {
              this.timeStart = "";
              this.timeEnd = "";
            }

            let labels = [];
            if (!this.environment && !this.theme) {
              labels = null;
            } else {
              if (this.environment) {
                labels.push(this.environment);
              }
              if (this.theme) {
                labels.push(this.theme);
              }

              labels = labels.join(",");
            }

            let peopleName = ''
            if (this.peopleFace) {
              if (this.peopleFace !== -1) {
                for (let i = 0; i < this.peopleFaceList.length; i++) {
                  if (this.peopleFaceList[i].id == this.peopleFace) {
                    peopleName = this.peopleFaceList[i].name
                  }

                }
              }

            }

            let params = {
              createUid: this.createUid,
              keyword: this.selectInput,
              libId: this.belongPic,
              timeStart: this.timeStart,
              timeEnd: this.timeEnd,
              page: this.page,
              pageSize: this.pageSize,
              orderByTime: this.orderByTime,
              status: this.statusId,
              peopleName: peopleName,
              labels: labels
            };
            this.advSearchPictureAsync(params)
            // console.log(this.picList)
          }, 1000);
        }

      }

    },

    //获取图片列表
    async listMyPowerLibAsync() {
      let { status, data, message, pagination } = await listMyPowerLib();
      if (status) {
        this.options = []
        this.belongPicList = [{
          id: 0,
          name: "全部"
        }]
        for (let i = 0; i < data.length; i++) {
          if (this.allowLib.indexOf(data[i].id.toString()) !== -1) {
            if (data[i].status === 1) {
              this.belongPicList.push({
                id: data[i].id,
                name: data[i].name,
                children:[]
              });
            }
          }

        }

        for (let i = 0; i < this.belongPicList.length; i++) {
            let flag = 0;
            for (let j = 0; j < this.allowLib.length; j++) {
              if (this.allowLib[j].toString().indexOf("-") !== -1) {
                if (
                  this.belongPicList[i].id == this.allowLib[j].split("-")[0]
                ) {
                  flag++;
                  this.belongPicList[i].children.push({
                    id: this.allowLib[j].split("-")[1],
                    name: "",
                  });
                }
              }
            }
            if (flag == 0) {
              delete this.belongPicList[i].children;
            }
          }

          for (let i = 0; i < this.belongPicList.length; i++) {
            if (this.belongPicList[i].hasOwnProperty("children")) {
              if (this.belongPicList[i].children.length > 0) {
                for (
                  let z = 0;
                  z < this.belongPicList[i].children.length;
                  z++
                ) {
                  for (let j = 0; j < data.length; j++) {
                    if (data[j].id == this.belongPicList[i].children[z].id) {
                      this.belongPicList[i].children[z].name = data[j].name;
                    }
                  }
                }
              }
            }
          }
      }
    },

    //获取图片库列表
    async listLibAsync() {
      let { status, data, message } = await listLib({ pageSize: 100 });
      if (status) {
        this.belongPicList = [
          {
            id: 0,
            name: "全部"
          }
        ]
        this.options = []
        if (localStorage.getItem('createUid') == 60000) {
          for (let i = 0; i < data.length; i++) {
            if (data[i].status === 1) {
              this.belongPicList.push({
                id: data[i].id,
                name: data[i].name,
                children:[]
              });
            }


          }
          for (let i = 0; i < this.belongPicList.length; i++) {
            let flag = 0;
            for (let j = 0; j < this.allowLib.length; j++) {
              if (this.allowLib[j].toString().indexOf("-") !== -1) {
                if (
                  this.belongPicList[i].id == this.allowLib[j].split("-")[0]
                ) {
                  flag++;
                  this.belongPicList[i].children.push({
                    id: this.allowLib[j].split("-")[1],
                    name: "",
                  });
                }
              }
            }
            if (flag == 0) {
              delete this.belongPicList[i].children;
            }
          }

          for (let i = 0; i < this.belongPicList.length; i++) {
            if (this.belongPicList[i].hasOwnProperty("children")) {
              if (this.belongPicList[i].children.length > 0) {
                for (
                  let z = 0;
                  z < this.belongPicList[i].children.length;
                  z++
                ) {
                  for (let j = 0; j < data.length; j++) {
                    if (data[j].id == this.belongPicList[i].children[z].id) {
                      this.belongPicList[i].children[z].name = data[j].name;
                    }
                  }
                }
              }
            }
          }
        } else {
          this.listMyPowerLibAsync()
        }
      }
      if (data) {
        this.belongPicList = [
          {
            id: 0,
            name: "全部"
          }
        ]
        this.options = []
        if (localStorage.getItem('createUid') == 60000) {
          for (let i = 0; i < data.length; i++) {
            if (data[i].status === 1) {
              this.belongPicList.push({
                id: data[i].id,
                name: data[i].name,
                children:[]
              });
            }


          }

        } else {
          for (let i = 0; i < data.length; i++) {
            if (this.allowLib.indexOf(data[i].id.toString()) !== -1) {
              if (data[i].status === 1) {
                this.belongPicList.push({
                  id: data[i].id,
                  name: data[i].name,
                  children:[]
                });
              }


            }

          }
        }

        for (let i = 0; i < this.belongPicList.length; i++) {
            let flag = 0;
            for (let j = 0; j < this.allowLib.length; j++) {
              if (this.allowLib[j].toString().indexOf("-") !== -1) {
                if (
                  this.belongPicList[i].id == this.allowLib[j].split("-")[0]
                ) {
                  flag++;
                  this.belongPicList[i].children.push({
                    id: this.allowLib[j].split("-")[1],
                    name: "",
                  });
                }
              }
            }
            if (flag == 0) {
              delete this.belongPicList[i].children;
            }
          }

          for (let i = 0; i < this.belongPicList.length; i++) {
            if (this.belongPicList[i].hasOwnProperty("children")) {
              if (this.belongPicList[i].children.length > 0) {
                for (
                  let z = 0;
                  z < this.belongPicList[i].children.length;
                  z++
                ) {
                  for (let j = 0; j < data.length; j++) {
                    if (data[j].id == this.belongPicList[i].children[z].id) {
                      this.belongPicList[i].children[z].name = data[j].name;
                    }
                  }
                }
              }
            }
          }
      }
    },




    //检索图片
    async advSearchPictureAsync(val) {

      let { status, data, message, pagination, errors } = await advSearchPicture(val);
      if (status) {
        if (this.page === 0) {
          this.picList = data
        } else {
          for (let i = 0; i < data.length; i++) {
            this.picList.push(data[i])
          }
        }

        this.total = pagination.total
        for (let i = 0; i < this.picList.length; i++) {
          this.picList[i].isLove = false
          this.picList[i].id = this.picList[i].resourceId
          if (this.picList[i].picThumbH160) {
            this.picList[i].src =
              picPrefix + this.picList[i].picThumbH160;
            this.picList[i].srcW1080 =
              picPrefix + this.picList[i].picThumbW1080;
          } else {
            this.picList[i].src = require("@/assets/house/onloadpicin.png");
            this.picList[
              i
            ].srcW1080 = picPrefix + this.picList[i].savepath;
          }


          //图片加载失败
          if (this.picList[i].picThumbH160 === "error") {
            this.picList[i].errortext = "error";
            this.picList[
              i
            ].src = require("@/assets/house/onloadpicerror.png");
            this.picList[
              i
            ].picThumbWh160 = require("@/assets/house/onloadpicerror.png");
            this.picList[
              i
            ].srcW1080 = picPrefix + this.picList[i].savepath;
          }
          let imgTest = new Image();
          imgTest.src = this.picList[i].src;
          imgTest.onerror = () => {
            this.picList[i].errortext = "error";
            this.picList[
              i
            ].src = require("@/assets/house/onloadpicerror.png");
            this.picList[
              i
            ].picThumbWh160 = require("@/assets/house/onloadpicerror.png");
            this.picList[
              i
            ].srcW1080 = picPrefix + this.picList[i].savepath;
          };
        }

        let picLoveString = sessionStorage.getItem("picLove");
        let picLoveArray = JSON.parse(picLoveString);
        console.log(picLoveArray);
        if (picLoveArray) {
          for (let j = 0; j < picLoveArray.length; j++) {
            for (let z = 0; z < this.picList.length; z++) {
              if (picLoveArray[j].id === this.picList[z].resourceId) {
                this.loveList.push(picLoveArray[j].id);
                this.picList[z].isLove = true;
              }
            }
          }
          this.setLoveList(this.loveList);
        } else {
          this.loveList = [];
          this.setLoveList(this.loveList);
        }

        this.$forceUpdate()
        this.firstLoading = false
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
        this.firstLoading = false
      }

    },


    //判断分辨率
    judgRes() {
      if (this.isAside && this.displayResolution > 1700) {
        this.atlasMargin = "16px"
      } else if (this.isAside && this.displayResolution < 1700) {
        this.atlasMargin = "38px"
      } else if (!this.isAside && this.displayResolution > 1700) {
        this.atlasMargin = "45px"
      } else if (!this.isAside && this.displayResolution < 1700) {
        this.atlasMargin = "75px"
      }
    },

  },
  created() {

    //获取选用图片
    this.getUserSettingAsync(this.createUid, 'picLove')

    //获取图库列表
    this.listLibAsync()

    //获取人物列表
    this.listPeopleAsync({ pageSize: 30 });


    this.displayResolution = document.documentElement.clientWidth;

    this.documentHeight = document.documentElement.clientHeight

    this.firstLoading = true
    let paramspic = {
      createUid: this.createUid,
      page: this.page,
      pageSize: this.pageSize,
      orderByTime: 0
    };
    this.advSearchPictureAsync(paramspic)


  },
  // activated: function () {
  //   this.refresh()
  // },
  mounted() {
    window.addEventListener("scroll", this.scrollMine);
    //获取侧边栏是否收起
    // this.bus.$on('changeIsaside', (message) => {
    //   this.bus.val = message
    //   this.isAside = this.bus.val
    // })
  },
  destroyed() {
    //离开这个界面之后，删除，不然会有问题
    window.removeEventListener("scroll", this.scrollMine);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./minepic.scss";
@import "@/constants/elHeader.scss";
/*滚动条样式*/
/deep/ ::-webkit-scrollbar {
  width: 10px;
  /*height: 4px;*/
}
/deep/ ::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}
/deep/ ::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.1);
}



.seepic /deep/ .el-dialog__header {
  display: none;
}
.seepic /deep/ .el-dialog__body {
  display: flex;
  padding: 0;
}
</style>
